import script from "./Title.vue?vue&type=script&setup=true&lang=js"
export * from "./Title.vue?vue&type=script&setup=true&lang=js"

import "./Title.vue?vue&type=style&index=0&id=078d4e09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-078d4e09"]])

export default __exports__